var React = require('react');

function Nigeria (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z","fill":"#F0F0F0","key":0}),React.createElement("path",{"d":"M0 9.99906C0 14.2988 2.71375 17.9641 6.52176 19.3771V0.621094C2.71375 2.03398 0 5.69945 0 9.99906Z","fill":"#6DA544","key":1}),React.createElement("path",{"d":"M20.0003 9.99906C20.0003 5.69945 17.2865 2.03398 13.4785 0.621094V19.3771C17.2865 17.9641 20.0003 14.2987 20.0003 9.99906Z","fill":"#6DA544","key":2})]);
}

Nigeria.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Nigeria;

Nigeria.default = Nigeria;
